import React, { useState } from 'react';
import _ from 'lodash';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import type ExpensesAccountType from '@this/domain/expenses/expenses_account_type';
import type FreeeAccountItem from '@this/domain/organization/freee_account_item';
import Modal from '@this/shared/modal/modal';
import { Fetcher, HTTPError } from '@this/src/util';
import Form from './form';

type Props = {
  type: ExpensesAccountType;
  isFreeeConnected: boolean;
  freeeAccountItems: FreeeAccountItem[];
  onSubmit: () => void;
  hideModal: () => void;
};

const EditFormModal: React.FC<Props> = ({ type, isFreeeConnected, freeeAccountItems, onSubmit, hideModal }) => {
  const [submitting, setSubmitting] = useState(false);
  const [submitErrors, setSubmitErrors] = useState<string[]>([]);

  const updateType = async () => {
    setSubmitting(true);
    setSubmitErrors([]);
    try {
      await Fetcher.put(`/organization/expenses_account_types/${type.id}`, type.submitParams());
      setSubmitting(false);
      onSubmit();
    } catch (e) {
      if (e instanceof HTTPError && e.response?.data) {
        const error = e.response.data.error ?? e.response.data.errors ?? e.response.data.message;
        setSubmitErrors(Array.isArray(error) ? error : error ? [error] : []);
      } else {
        setSubmitErrors(['通信エラーが発生しました。時間をおいて再度お試しください。']);
      }
      setSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSubmitErrors([]);
  };

  return (
    <>
      <Snackbar
        open={submitErrors.length > 0}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert onClose={handleCloseSnackbar} severity="error">
          {submitErrors.map((message, i) => (
            <div key={i}>{message}</div>
          ))}
        </MuiAlert>
      </Snackbar>
      <Modal show hideModal={hideModal} title="勘定科目を変更する" className="e2e-modal-edit">
        <Form
          type={type}
          isFreeeConnected={isFreeeConnected}
          freeeAccountItems={freeeAccountItems}
          submitting={submitting}
          onSubmit={updateType}
          onClickCancel={hideModal}
        />
      </Modal>
    </>
  );
};

export default EditFormModal;
